import {Component, OnInit} from '@angular/core';
import { DatePipe, DecimalPipe } from "@angular/common";

import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ApiService, CustomerDebtRecord, VOC, VOCType } from "../../../../../projects/accounting/src/public_api";

import { DetailsViewerComponent } from './details-viewer/details-viewer.component';
import { PaymentEditorComponent, PaymentEditorType } from '../../popups/payment-editor/payment-editor.component';
import { VOCEditorComponent } from '../../popups/voc-editor/voc-editor.component';
import { MessageBoxComponent, MessageBoxData } from '../../../../../projects/jv-ui/src/public_api';
import { CachingService } from '../../../../../projects/jv-common/src/lib/services/caching.service';


@Component({
  selector: 'app-debts-customer',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  modalRef: BsModalRef;

  constructor(
    private modal: BsModalService,
    private cache: CachingService,
    private api: ApiService,
    private decimal: DecimalPipe,
    private date: DatePipe
  ) {
  }

  public dtConfig = null;
  public loading = false;
  private period = null;
  private currentPeriod = null;
  private nextPeriod = null;

  private generate(data: Array<CustomerDebtRecord>, period) {
    if (this.nextPeriod == period) {
      return {
        data: data,

        group: i => {

          let parts = i.info.address.split(',');

          if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

          return { parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim() }
        },

        txt: i => [i.info.name, i.info.address, i.info.contact, i.info.phone, i.info.email].join(' '),

        title: 'CÔNG NỢ CỦA KHÁCH HÀNG ' + period,
        columns: [
          {
            title: 'Khách hàng',
            html: function (i) {
              return '<b>' + i.info.name + '</b><br><small>' + i.info.address + '</small>';
            },
          },
          {
            title: 'Liên hệ',
            html: i => {
              let html = '';
              i.info.contact != '' ? html += '<div class="text-primary"><i class="fa fa-user"></i>' + i.info.contact + '</div>' : '';
              i.info.phone != '' ? html += '<div class="text-danger"><i class="fa-phone fa"></i>' + i.info.phone + '</div>' : '';
              i.info.email != '' ? html += '<div><i class="fa-envelope fa"></i>' + i.info.email + '</div>' : '';

              return html;
            },
            css: i => 'custom-info text-uppercase',
            click: i => this.edit(i)
          },
          {
            title: 'Tổng công nợ',
            class: 'text-right',
            html: i => i.debt > 0 ? '<b>' + this.decimal.transform(i.debt, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>' : '',
            css: i => 'text-right text-danger',
            click: i => {
              i.debt > 0 ? this.view(i.info) : '';
            }
          },
          {
            title: 'Đã đặt cọc',
            class: 'text-right',
            html: i => '<b>' + this.decimal.transform(i.returned, '1.0-0', 'en-US') + '</b><br><small class="text-success"><i>Ghi nhận đặt cọc</i></small>',
            css: i => 'text-right text-success',
            click: i => this.collect(i)
          }
        ],

        footer: data => {
          let Debt = 0;
          let FutureTurnOver = 0;
          let HistoryTurnOver = 0;
          let Returned = 0;
          let DTR = 0;
          let RTD = 0;
          data.forEach(i => {
            Debt += i.debt;
            Returned += i.returned;
            DTR += i.debt - i.returned > 0 ? i.debt - i.returned : 0;
            RTD += i.returned - i.debt > 0 ? i.returned - i.debt : 0;
          });

          return [
            { html: '<b>TỔNG</b>' },
            { html: '' },
            {
              html: '<b>' + this.decimal.transform(Debt, '1.0-0', 'en-US') + '</b>',
              class: 'text-right text-danger'
            },
            {
              html: '<b>' + this.decimal.transform(Returned, '1.0-0', 'en-US') + '</b>',
              class: 'text-right text-success'
            }
          ];
        }
      }
    }
    /* ========================  */
    return {
      data: data,

      group: i => {

        let parts = i.info.address.split(',');

        if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

        return { parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim() }
      },

      txt: i => [i.info.name, i.info.address, i.info.contact, i.info.phone, i.info.email].join(' '),

      title: 'CÔNG NỢ CỦA KHÁCH HÀNG ' + period,
      columns: [
        {
          title: 'Khách hàng',
          html: function (i) {
            return '<b>' + i.info.name + '</b><br><small>' + i.info.address + '</small>';
          },
        },
        {
          title: 'Liên hệ',
          html: i => {
            let html = '';
            i.info.contact != '' ? html += '<div class="text-primary"><i class="fa fa-user"></i>' + i.info.contact + '</div>' : '';
            i.info.phone != '' ? html += '<div class="text-danger"><i class="fa-phone fa"></i>' + i.info.phone + '</div>' : '';
            i.info.email != '' ? html += '<div><i class="fa-envelope fa"></i>' + i.info.email + '</div>' : '';

            return html;
          },
          css: i => 'custom-info text-uppercase',
          click: i => this.edit(i)
        },
        {
          title: 'Tổng công nợ',
          class: 'text-right',
          html: i => '<b>' + this.decimal.transform(i.debt, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>',
          css: i => 'text-right text-danger',
          click: i => this.view(i.info)
        },
        {
          title: 'Đã thu',
          class: 'text-right',
          html: i => '<b>' + this.decimal.transform(i.returned, '1.0-0', 'en-US') + '</b>',
          css: i => 'text-right text-success'
        },

        {
          title: 'Thiếu',
          class: 'text-right',
          html: i => {
            let left = i.debt - i.returned;
            return Math.round(left) <= 0 ? '0' : '<b class="text-danger">' + this.decimal.transform(left, '1.0-0', 'en-US') + '</b><br><small class="text-success"><i>' + (this.period != this.nextPeriod ? 'Ghi nhận thu' : 'Ghi nhận đặt cọc') + '</i></small>';
          },
          css: i => 'text-right',
          click: i => this.collect(i)
        },
        {
          title: 'Thừa',
          class: 'text-right',
          html: i => {
            let excess = i.returned - i.debt;
            return Math.round(excess) < 0 ? '0' : Math.round(excess) > 10000 ? '<b class=" text-warning">' + this.decimal.transform(excess, '1.0-0', 'en-US') + '</b>' : this.decimal.transform(excess, '1.0-0', 'en-US');
          },
          css: i => 'text-right',
        }
      ],

      footer: data => {
        let Debt = 0;
        let FutureTurnOver = 0;
        let HistoryTurnOver = 0;
        let Returned = 0;
        let DTR = 0;
        let RTD = 0;
        data.forEach(i => {
          Debt += i.debt;
          Returned += i.returned;
          DTR += i.debt - i.returned > 0 ? i.debt - i.returned : 0;
          RTD += i.returned - i.debt > 0 ? i.returned - i.debt : 0;
        });

        return [
          { html: '<b>TỔNG</b>' },
          { html: '' },
          {
            html: '<b>' + this.decimal.transform(Debt, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-danger'
          },
          {
            html: '<b>' + this.decimal.transform(Returned, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-success'
          },

          {
            html: '<b>' + this.decimal.transform(DTR, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-danger'
          },
          {
            html: '<b>' + this.decimal.transform(RTD, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-warning'
          },
        ];
      }
    }
  }

  private history = {};

  private getRemainingDebt(record) {
    return record.DebtToBrand + record.TurnOverOfBrand + record.DebtToWarehouses + record.TurnOverOfWareHouses - record.Returned;
  }

  ngOnInit() {

    let anchor = new Date();

    this.nextPeriod = this.date.transform(anchor, "MM-yyyy");

    anchor.setMonth(anchor.getMonth() - 1)

    this.currentPeriod = this.date.transform(anchor, "MM-yyyy");

    this.cache.get("customer-payment-history", {}).subscribe(data => this.history = data);
  }

  load(period) {

    // this.dtConfig = null;
    this.loading = true;

    this.api.debtOfCustomers(period).subscribe(response => {

      if (response.succeed) {

        let data: Array<CustomerDebtRecord> = [];

        response.data.sort((a, b) => a.Debt - a.Returned > b.Debt - b.Returned ? -1 : 1).forEach(i => data.push({
          info: {
            id: i.ID,
            name: i.Name,
            address: i.Address,
            type: VOCType.customer,
            phone: i.Phone,
            email: i.Email,
            contact: i.Contact
          },

          debt: i.Debt,
          returned: i.Returned
        }));

        this.period = period;
        this.dtConfig = this.generate(data, period);
      }

      this.loading = false;
    });
  }

  collect(record: CustomerDebtRecord) {

    this.modalRef = this.modal.show(PaymentEditorComponent, {
      class: 'modal-md',
      initialState: {
        data: {
          name: record.info.name,
          shortName: 'KH',
          address: record.info.address,
          type: PaymentEditorType.income,
          accounts: [{ name: 'CASH' }],
          account: typeof this.history["#" + record.info.id] == "undefined" ? null : this.history["#" + record.info.id],
          amount: Math.max(0, record.debt - record.returned)
        }
      }
    }).content.commit.subscribe(data => {


      if (typeof this.history["#" + record.info.id] == "undefined" || this.history["#" + record.info.id] != data.account) {
        this.history["#" + record.info.id] = data.account;

        this.cache.set("customer-payment-history", this.history).subscribe(succeed => { });
      }

      let request = {
        ID: record.info.id,
        Amount: this.nextPeriod == this.period ? 0 : data.amount,
        Bank: data.account,
        Period: this.period,
        Date: data.date
      };

      this.loading = true;

      this.api.collectFromCustomer(request).subscribe(
        response => {

          this.loading = false;

          if (response.succeed && response.data) {
            record.returned += data.amount;
          }
          else {
            this.error("Không tạo được " + (this.period == this.nextPeriod ? " đặt cọc" : " ghi nhận thu"));
          }
        },
        error => {
          this.loading = false;
          this.error("Không tạo được " + (this.period == this.nextPeriod ? " đặt cọc" : " ghi nhận thu"));
        }
      );
    });
  }

  error(message: string) {

    let data: MessageBoxData = {
      title: "LỖI",
      content: '<div class="text-danger text-center">' + message + '</div>',
      buttons: [{ name: "OK", class: "bg-danger" }],
      closable: true,
      header: true
    };

    this.modal.show(MessageBoxComponent, {
      class: 'modal-md', initialState: {
        data: data
      }
    });
  }

  edit(record: CustomerDebtRecord) {
    this.modal.show(VOCEditorComponent, {
      class: 'modal-md',
      initialState: {
        data: {
          info: record.info
        }
      }
    }).content.change.subscribe(data => {

      let request = {
        ID: data.info.id,
        Phone: data.info.phone,
        Email: data.info.email,
        Mode: data.info.type,
        Name: data.info.contact,
      };

      this.loading = true;

      this.api.updateVOC(request).subscribe(
        response => {
          if (response.succeed && response.data) record.info = data.info;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      );
    });
  }

  view(customer: VOC) {
    this.modal.show(DetailsViewerComponent, {
      class: 'modal-lg',
      initialState: {
        data: {
          customer: customer,
          period: this.period
        }
      }
    });
  }
}
